import React from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';

import Helmet from "react-helmet";

import {DebugContainer} from "./Debug/Debug";
import {getPageData, SeoComponent, StructureDebug} from "./structure/jigpawsStructure";


const useStyles = makeStyles((theme) => ({
    container: {
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: '#fff',
    },
    wrapper: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        flexGrow: 1,
        width: 1024,
        margin: "auto",
        [theme.breakpoints.down('lg')]: {
            width: "100%",
            margin: "none,"
        },
    },
    header: {
        background: '#fff',
        color: '#413e40',
        textAlign: "left",
        marginLeft: 40,
        marginTop: 40,
        marginBottom: 20,
    },
    section: {
        background: '#fff',
        color: '#413e40',
        textAlign: "left",
        marginLeft: 40,
        marginTop: 20,
        marginBottom: 20,
        marginRight: 40,
    }
}));


export default function Deliveries() {
    const classes = useStyles();
    const pageData = getPageData({
    pageType: "Delivery",
    });

    return (

        <React.Fragment>
            <Helmet>
                {/*<title>Jigpaws – Free shipping | Delivery times and FAQs</title>*/}
                {/*<meta name="description"*/}
                {/*      content="Free shipping | Delivery times and FAQs"/>*/}
                {/*/!*<link rel="canonical" href="https://www.jigpaws.com/deliveries-and-returns"/>*!/*/}
                {/*<meta property="og:url"*/}
                {/*      content="https://www.jigpaws.com/deliveries-and-returns"/>*/}
                {/*<meta property="og:type" content="article"/>*/}
                {/*<meta property="og:title" content="Jigpaws – Free shipping | Delivery times and FAQs"/>*/}
                {/*<meta property="og:description"*/}
                {/*      content="Simply upload one of your many pet photos and create a lovingly crafted personalised pet photo gift to share with friends and family around the world."/>*/}
                {/*<meta property="og:image" content="https://www.jigpaws.com/images/social-logo.png"/>*/}
            </Helmet>

                 <SeoComponent page={pageData} />
                <DebugContainer><StructureDebug pageData={pageData}/></DebugContainer>
            <div className={classes.container}>
                <Container className={"productsHome bgGray"} disableGutters={true} maxWidth={false}>
                    <div className="spacer"/>
                    <div><h1>DELIVERIES & RETURNS</h1></div>
                    <div className="spacer"></div>
                    <div className="jpDivider bgBlue"/>

                </Container>

                <div className={classes.wrapper}>

                    <Paper elevation={0} square={true} className={classes.section}>
                        <body>
                        <div className="tcCopy">
                            <p>Every Jigpaws product is personalised and lovingly handmade to order. Wherever
                                possible, we make your gift close to home, helping it reach you faster and reducing
                                unnecessary miles along the way.</p>
                        </div>
                        </body>
                    </Paper>
                    <Paper elevation={0} square={true} className={classes.section}>
                        <h3>FREE SHIPPING</h3>
                        <div className="spacerMed"/>

                        <h4><strong>🇬🇧 UK</strong></h4>
                        <body>
                        <div className="tcCopy">
                            <p>FREE UK shipping on every Jigpaws product.</p>
                        </div>
                        <p>All orders for UK customers are handmade to order in the UK, including:</p>
                        <strong>• </strong>Jigsaw Puzzles<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>Cushions<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>Photo Books<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>Photo Tiles<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>Notebooks<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>Greeting Cards<br/>
                        <div className="spacerSmall"/>
                        <p>Once your order has been handcrafted, it will be dispatched as soon as it is ready.</p>
                        </body>
                        <div className="spacerMed"/>

                        <h4><strong>🇺🇸 USA</strong></h4>
                        <body>
                        <div className="tcCopy">
                            <p>FREE US shipping on:</p>
                        </div>
                        <strong>• </strong>Jigsaw Puzzles<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>Cushions<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>Photo Books<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>Photo Tiles<br/>
                        <div className="spacerSmall"/>
                        <p>Our Cushions, Photo Books and Photo Tiles are handmade to order in the USA for US
                            customers.</p>
                        <p>Our Jigsaw Puzzles are handmade in the UK and shipped to the USA free of charge.</p>
                        <p>Shipping costs for other products are shown at checkout.</p>
                        </body>
                        <div className="spacerMed"/>

                        <h4><strong>🇪🇺 Europe</strong></h4>
                        <body>
                        <div className="tcCopy">
                            <p>Selected Jigpaws products can be handmade to order in Europe, helping reduce shipping
                                distances and delivery times.</p>
                        </div>
                        <p>Products with European fulfilment include:</p>
                        <strong>• </strong>Photo Books<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>Photo Tiles<br/>
                        <div className="spacerSmall"/>
                        <p>Our Photo Books can be fulfilled in the UK, EU, US, Canada, Mexico, Australia and
                            Sweden.</p>
                        <p>Our Photo Tiles can be fulfilled in the UK, EU and US.</p>
                        <p>Jigsaw Puzzles include FREE worldwide shipping, including delivery to Europe.</p>
                        <p>Shipping costs for other products are calculated at checkout.</p>
                        </body>
                        <div className="spacerMed"/>

                        <h4><strong>🌍 Rest of the World</strong></h4>
                        <body>
                        <div className="tcCopy">
                            <p>Jigsaw Puzzles come with FREE worldwide shipping.</p>
                        </div>
                        <p>So wherever you are, you can turn your favourite photo into a personalised 500 or 1000
                            piece Jigpaws puzzle without paying extra for delivery.</p>
                        <p>Our Photo Books are also produced locally in a number of regions, including Canada,
                            Mexico and Australia, where available.</p>
                        <p>Shipping costs for Cushions, Photo Books, Photo Tiles, Notebooks and Greeting Cards
                            outside our free-shipping regions are calculated at checkout.</p>
                        </body>
                    </Paper>
                    <Paper elevation={0} square={true} className={classes.section}>
                        <h3>PRODUCTION & DELIVERY TIMES</h3>
                        <div className="spacerMed"/>

                        <body>
                        <div className="tcCopy">
                            <p>Because every Jigpaws product is personalised and made especially for you, we need a
                                little time to create it before it can be dispatched.</p>
                        </div>
                        </body>
                        <div className="spacerSmall"/>
                        <h4><strong>Jigsaw Puzzles</strong></h4>
                        <body>
                        <div className="tcCopy">
                            <p>Lovingly handmade to order in the UK.</p>
                        </div>
                        <strong>• </strong>Production: approximately 2–3 working days<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>UK delivery: approximately 1–2 working days after dispatch<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>International delivery: usually within 7 working days after dispatch<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>FREE UK, US and worldwide shipping<br/>
                        </body>
                        <div className="spacerMed"/>
                        <h4><strong>Cushions</strong></h4>
                        <body>
                        <div className="tcCopy">
                            <p>Printed, dried, stitched and finished by hand in the UK or USA.</p>
                        </div>
                        <strong>• </strong>Production: approximately 3–5 working days<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>UK & US delivery: approximately 1–2 working days after dispatch<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>FREE UK & US shipping<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>Shipping to other destinations is calculated at checkout<br/>
                        </body>
                        <div className="spacerMed"/>
                        <h4><strong>Photo Books</strong></h4>
                        <body>
                        <div className="tcCopy">
                            <p>Our personalised hardcover Photo Books are individually printed and bound to order.
                                Depending on your location, they can be fulfilled in the UK, Europe, USA, Canada,
                                Mexico, Australia and Sweden.</p>
                        </div>
                        <strong>• </strong>Production: approximately 3–5 working days<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>Delivery: calculated according to destination and local fulfilment<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>FREE UK & US shipping<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>Shipping to other destinations is calculated at checkout<br/>
                        </body>
                        <div className="spacerMed"/>
                        <h4><strong>Photo Tiles</strong></h4>
                        <body>
                        <div className="tcCopy">
                            <p>Your personalised Photo Tile is printed, framed and made to order. Photo Tiles can be
                                fulfilled in the UK, Europe and USA.</p>
                        </div>
                        <strong>• </strong>Production: approximately 2–3 working days<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>Delivery: calculated according to destination and local fulfilment<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>FREE UK & US shipping<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>Shipping to other destinations is calculated at checkout<br/>
                        </body>
                        <div className="spacerMed"/>
                        <h4><strong>Notebooks</strong></h4>
                        <body>
                        <div className="tcCopy">
                            <p>Our personalised Notebooks are handmade to order in the UK for UK customers.</p>
                        </div>
                        <strong>• </strong>Production: approximately 2–3 working days<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>UK delivery: approximately 1–2 working days after dispatch<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>FREE UK shipping<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>International shipping is calculated at checkout<br/>
                        </body>
                        <div className="spacerMed"/>
                        <h4><strong>Greeting Cards</strong></h4>
                        <body>
                        <div className="tcCopy">
                            <p>Our personalised Greeting Cards are printed to order in the UK for UK customers.</p>
                        </div>
                        <strong>• </strong>Production: approximately 1–3 working days<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>UK delivery: approximately 1–2 working days after dispatch<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>FREE UK shipping<br/>
                        <div className="spacerSmall"/>
                        <strong>• </strong>International shipping is calculated at checkout<br/>
                        </body>
                        <div className="spacerMed"/>
                        <div className="spacerMed"/>

                        <h3>TRACKING YOUR ORDER</h3>
                        <div className="spacerMed"/>
                        As soon as your order has been handmade and dispatched, we'll send you a confirmation email
                        with your delivery information and tracking details where available.<br/>
                        <div className="spacerSmall"/>
                        Please remember that the delivery time shown above begins after your personalised product
                        has been made.<br/>
                        <div className="spacerSmall"/>
                        If your order hasn't arrived within 3 working days of the expected UK delivery date, or
                        within 10 working days for an international order, please email <Link underline={"none"}
                                                                                           variant={"p"}
                                                                                           className={classes.link}
                                                                                           rel="noopener"
                                                                                           href="mailto:support@jigpaws.com">support@jigpaws.com</Link> and
                        we'll happily look into it for you.
                    </Paper>
                    <Paper elevation={0} square={true} className={classes.section}>

                        {/*<h3>CHRISTMAS</h3>*/}
                        {/*<div className="spacerSmall"/>*/}

                        <body>
                        {/*<div className="tcCopy">*/}
                        {/*    <p>Please place your order before the 17th of December to allow Father Christmas time to*/}
                        {/*        drop your gifts off.</p>*/}
                        {/*</div>*/}
                        </body>
                    </Paper>
                    <Paper elevation={0} square={true} className={classes.section}>
                        <h2>Returns & Refunds</h2>
                        <div className="spacerSmall"/>

                        <body>
                        <div className="tcCopy">
                            <p>Every Jigpaws product is personalised and handmade especially for you. Because
                                personalised products cannot be resold, we are unable to accept returns simply
                                because you have changed your mind.</p>
                        </div>
                        Please take a moment to check your photograph, cropping, positioning and any other
                        personalisation carefully before placing your order. Your product will be created using the
                        image and design you approve when ordering.
                        <br/><br/>
                        <strong>Something wrong with your order?</strong><br/>
                        <div className="spacerSmall"/>
                        If your order arrives damaged, faulty or has been made incorrectly, please get in touch with
                        us at <Link underline={"none"} variant={"p"} className={classes.link} rel="noopener"
                                    href="mailto:support@jigpaws.com">support@jigpaws.com</Link>.<br/>
                        We'll ask for a photograph of the problem so we can put things right as quickly as
                        possible.<br/>
                        Depending on the issue, we'll happily arrange an appropriate replacement or refund.
                        <br/><br/>
                        Any refund will be returned to your original payment method and will normally appear within
                        5–10 working days after it has been processed.
                        <br/><br/>
                        If you haven't received an agreed refund within 20 days, please contact us and we'll
                        investigate.
                        </body>

                        <div className="spacer"/>
                    </Paper>
                    <Paper elevation={0} square={true} className={classes.section}>
                        <h3>NEED SOME HELP?</h3>
                        <div className="spacerMed"/>

                        <body>
                        <div className="tcCopy">
                            <p>We're a small independent team and we're always happy to help.</p>
                        </div>
                        If you have any questions about production, shipping, your photograph or an existing order,
                        email us at:<br/>
                        <div className="spacerSmall"/>
                        <Link underline={"none"} variant={"p"} className={classes.link} rel="noopener"
                              href="mailto:support@jigpaws.com">support@jigpaws.com</Link>
                        <br/><br/>
                        <p>Happy creating! 🐶😻🦄</p>
                        </body>

                        <div className="spacer"/>
                    </Paper>
                </div>
            </div>
        </React.Fragment>
    );
}